var _mask, _rect, _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMicrofilm = function SvgMicrofilm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5815_42412",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.205078,
    y: 9.91455,
    width: 18.0902,
    height: 11.913,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.205078,
    y: 9.91455,
    width: 18.0902,
    height: 11.913,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 2.8,
    mask: "url(#path-1-inside-1_5815_42412)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.89463,
    cy: 7.02476,
    r: 3.15288,
    stroke: "currentColor",
    strokeWidth: 1.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.6056,
    cy: 7.02476,
    r: 3.15288,
    stroke: "currentColor",
    strokeWidth: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3 12.2666L23.3 19.646C23.3 19.8545 23.0925 19.9995 22.8967 19.9277L18.2628 18.2285C18.1447 18.1852 18.0661 18.0727 18.0661 17.9469L18.0661 14.5321C18.0661 14.4175 18.1314 14.3129 18.2343 14.2626L22.8682 11.9971C23.0675 11.8996 23.3 12.0447 23.3 12.2666Z",
    stroke: "currentColor",
    strokeWidth: 1.4
  })));
};
export default SvgMicrofilm;